export enum CrimeType {
  None = "",
  SHOPLIFT = "SHOPLIFT", //"shoplift",
  ROB_STORE = "ROBSTORE", //"rob a store",
  MUG = "MUG", //"mug someone",
  LARCENY = "LARCENY", //"commit larceny",
  DRUGS = "DRUGS", //"deal drugs",
  BOND_FORGERY = "BONDFORGERY", //"forge corporate bonds",
  TRAFFIC_ARMS = "TRAFFICKARMS", //"traffick illegal arms",
  HOMICIDE = "HOMICIDE", //"commit homicide",
  GRAND_THEFT_AUTO = "GRANDTHEFTAUTO", //"commit grand theft auto",
  KIDNAP = "KIDNAP", //"kidnap someone for ransom",
  ASSASSINATION = "ASSASSINATION", //"assassinate a high-profile target",
  HEIST = "HEIST", //"pull off the ultimate heist",
}
